import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  label: string;
  path: string;
}

const navItems: NavItem[] = [
  { label: '首页', path: '/' },
  { label: '分类大全', path: '/category' },
  { label: '排行榜', path: '/category?sort=popular' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          aria-label="韩漫网首页"
        >
          <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-book-open-line text-background-50 text-lg"></i>
          </span>
          <span className="text-xl font-heading font-bold text-foreground-900 whitespace-nowrap">
            韩漫网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`relative text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                isActive(item.path)
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              {item.label}
              {isActive(item.path) && (
                <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-accent-500 rounded-full" />
              )}
            </Link>
          ))}
        </div>

        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`block py-3 text-sm font-medium border-b border-background-100 last:border-0 ${
                isActive(item.path)
                  ? 'text-primary-600'
                  : 'text-foreground-700'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}